import React from 'react';
class FakeStackOverflow extends React.Component {
    constructor(props) {
        super(props);
        let storedName = '';
        try {
            storedName = localStorage.getItem('fso_last_name') || '';
        } catch (e) {
            storedName = '';
        }
        this.state = {
            questions: [],
            tags: [],
            currentPage: "main",
            filteredQuestions: null,
            searchTerm: '',
            activeButton: 'newest',
            title: '',
            details: '',
            tags_text: '',
            username: storedName,
            charCount: 0,
            answerUsername: storedName,
            answerText: '',
            currentQid: null,
            loading: false,
            error: null,
            submitting: false
        };

        this.fetchData = this
            .fetchData
            .bind(this);
        this.handleSearchBoxKeyUp = this
            .handleSearchBoxKeyUp
            .bind(this);
        this.handleQuestionsClick = this
            .handleQuestionsClick
            .bind(this);
        this.handleTagsClick = this
            .handleTagsClick
            .bind(this);
        this.renderAnswerPage = this
            .renderAnswerPage
            .bind(this);
    }

    initializeAndFetchData = async () => {
        this.setState({ filteredQuestions: null, activeButton: 'newest' });
        await this.fetchData();
    };

    componentDidMount() {
        // D3: restore initial page from the URL hash (supports refresh + back/forward).
        const hash = window.location.hash;
        let initialPage = 'main';
        if (hash === '#tags') {
            initialPage = 'tags';
        } else if (hash === '#ask') {
            initialPage = 'ask';
        }
        this.setState({ currentPage: initialPage });
        window.addEventListener('popstate', this.handlePopState);
        this.initializeAndFetchData();
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    handlePopState = (e) => {
        const page = (e.state && e.state.page) || 'main';
        this.setState({ currentPage: page });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentPage !== this.state.currentPage) {
            const page = this.state.currentPage;
            let hash = '#questions';
            if (page === 'ask') {
                hash = '#ask';
            } else if (page === 'tags') {
                hash = '#tags';
            } else if (page === 'answer') {
                hash = `#question/${this.state.currentQid}`;
            } else if (page === 'make_answer') {
                hash = '#answer';
            }
            if (window.location.hash !== hash) {
                window.history.pushState(
                    { page: this.state.currentPage, qid: this.state.currentQid },
                    '',
                    hash
                );
            }
        }
    }

    async fetchData() {
        this.setState({ loading: true, error: null });
        try {
            const [questionsRes, tagsRes] = await Promise.all([
                fetch('/api/questions'),
                fetch('/api/tags')
            ]);
            if (!questionsRes.ok) {
                throw new Error(
                    `Failed to fetch questions: ${questionsRes.status} ${questionsRes.statusText}`
                );
            }
            if (!tagsRes.ok) {
                throw new Error(
                    `Failed to fetch tags: ${tagsRes.status} ${tagsRes.statusText}`
                );
            }
            const questions = await questionsRes.json();
            const tags = await tagsRes.json();
            this.setState({ questions, tags, loading: false });
        } catch (error) {
            console.error('Failed to fetch data:', error);
            this.setState({ loading: false, error: 'Failed to load questions. Please try again.' });
        }
    }

    // 1. MAIN PAGE
    // ---------------------------------------------------

    // Main title header button
    handleMainTitleClick = () => {
        this.setState({
            currentPage: "main"
        }, () => {
            this.initializeAndFetchData();
            this.resetPageStyles();
        });
    };

    resetPageStyles = () => {
        document
            .getElementById("questions")
            .style
            .backgroundColor = "rgb(198, 198, 198)";
        document
            .getElementById("tags")
            .style
            .backgroundColor = "white";
    };

    resetPageStylesRev = () => {
        document
            .getElementById("questions")
            .style
            .backgroundColor = "white";
        document
            .getElementById("tags")
            .style
            .backgroundColor = "rgb(198, 198, 198)";
    };

    // 1-1 SEARCH BOX ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    handleSearchBoxKeyUp(event) {
        if (event.key === "Enter") {
            this.searchQuestions(event.target.value.trim());
            this.setState({
                searchTerm: ''
            }, () => {
                document
                    .getElementById("search_box_input")
                    .value = "";
            });
            this.resetPageStyles();
        }
    }

    searchQuestions = (searchTerm) => {
        const tagRegex = /\[([^\]]+)\]/g;
        let tags = [];
        let match;

        // Extract tags and remove them from the searchTerm
        while ((match = tagRegex.exec(searchTerm))) {
            tags.push(match[1].toLowerCase());
        }

        let nonTagSearchTerm = searchTerm.replace(tagRegex, '').trim().toLowerCase();

        const filteredQuestions = this.state.questions.filter(question => {
            // Check if question matches the tag criteria
            const matchesTags = tags.length === 0 || question.tags.some(tag => tags.includes(tag.name.toLowerCase()));
            
            // Check if question matches the text criteria
            const matchesText = nonTagSearchTerm === '' ||
                question.title.toLowerCase().includes(nonTagSearchTerm) ||
                question.text.toLowerCase().includes(nonTagSearchTerm);

            return matchesTags && matchesText;
        });
        this.setState({ filteredQuestions: filteredQuestions, currentPage: 'main' });
    }
    
    
    
    
    
    
    handleQuestionsClick() {
        this.handleMainTitleClick();
    }

    handleTagsClick() {
        this.setState({currentPage: "tags"});
        this.resetPageStylesRev();
        this.handleButtonClick("newest");
    }


    handleButtonClick = (button) => {
        this.setState({ activeButton: button });
    };

    // Pure derivation: never mutates state.questions / state.filteredQuestions.
    getVisibleQuestions = () => {
        const base = this.state.filteredQuestions !== null ? this.state.filteredQuestions : this.state.questions;
        const list = [...base];
        const { activeButton } = this.state;
        if (activeButton === 'unanswered') {
            return list.filter(q => q.answers.length === 0)
                       .sort((a, b) => new Date(b.ask_date_time) - new Date(a.ask_date_time));
        }
        if (activeButton === 'active') {
            const activity = q => new Date((q.answers[0] && q.answers[0].ans_date_time) || q.ask_date_time);
            return list.sort((a, b) => activity(b) - activity(a));
        }
        // 'newest' (default)
        return list.sort((a, b) => new Date(b.ask_date_time) - new Date(a.ask_date_time));
    };




    renderButton = (id, label) => {
        const {activeButton} = this.state;
        return (
            <button
                key={id}
                onClick={() => this.handleButtonClick(id)}
                className={activeButton === id
                    ? "active"
                    : ""}>
                {label}
            </button>
        );
    };

    timeDifference = (current, previous) => {
        const elapsed = current - previous;
        const second = 1000;
        const minute = 60 * second;
        const hour = 60 * minute;
        const day = 24 * hour;
        if (elapsed < minute) {
            return `${Math.round(elapsed / second)} seconds ago`;
        } else if (elapsed < hour) {
            return `${Math.round(elapsed / minute)} minutes ago`;
        } else if (elapsed < day) {
            return `${Math.round(elapsed / hour)} hours ago`;
        } else if (current.getFullYear() === previous.getFullYear()) {
            return previous.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        } else {
            return previous.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        }
    };

    displayAllQuestions = () => {
        const questionsToDisplay = this.getVisibleQuestions();
        const { loading, error, filteredQuestions } = this.state;
        return (
            <div id="main" className="main">
                <div id="all_questions" className="page_title">
                    <div className="page_title">All Questions</div>
                </div>
                <button
                    id="ask_question"
                    className="blue_button ask_question"
                    onClick={() => {
                        this.setState({currentPage: "ask"});
                        document
                            .getElementById("tags")
                            .style
                            .backgroundColor = "white";
                        document
                            .getElementById("questions")
                            .style
                            .backgroundColor = "white";
                    }}>
                    Ask Question
                </button>
                <div id="question_header">
                    <p>
                        <span id="total_questions">{questionsToDisplay.length}</span>
                        questions
                    </p>
                    <div className="button_group">
                        {this.renderButton("newest", "Newest")}
                        {this.renderButton("active", "Active")}
                        {this.renderButton("unanswered", "Unanswered")}
                    </div>
                </div>
                {filteredQuestions !== null && (
                    <div className="results_header">
                        <span>Showing results ({questionsToDisplay.length})</span>
                        <button className="clear_link" onClick={this.handleMainTitleClick}>Clear</button>
                    </div>
                )}
                <div id="question_header_bottom_line"></div>
                {
                    loading
                        ? (
                            <div className="loading_line" style={{ margin: "10px", fontSize: "1.2em" }}>
                                Loading questions…
                            </div>
                        )
                        : error
                            ? (
                                <div className="error_line" style={{ margin: "10px" }}>
                                    <span>{error}</span>
                                    <button
                                        className="blue_button"
                                        style={{ marginLeft: "10px" }}
                                        onClick={this.initializeAndFetchData}>
                                        Retry
                                    </button>
                                </div>
                            )
                            : questionsToDisplay.length > 0
                                ? this.renderQuestions(questionsToDisplay)
                                : (
                                    <div
                                        className="no_questions_found"
                                        style={{
                                            margin: "10px",
                                            fontSize: "2em"
                                        }}>
                                        No questions found
                                    </div>
                                )
                }
            </div>
        );
    };

    renderQuestions = (questions) => {
        return questions.map((question, index) => {
            return (
                <div key={index} className="question_list">
                    <div className="question-views">
                        <div className="answer_count">{question.answers.length}
                            answers</div>
                        <span className="view_count">{question.views}
                            views</span>
                    </div>
                    <div className="content">
                        <h1 className="title" onClick={() => this.handleTitleClick(question)}>
                            {question.title}
                        </h1>
                        <div className="tags">
                            {this.renderTags(question.tags)}
                        </div>
                    </div>
                    <div className="question_metadata">
                        <span className="name">{question.asked_by}</span>
                        <span className="time">
                            {
                                this.timeDifference(
                                    new Date(),
                                    question.ask_date_time
                                        ? new Date(question.ask_date_time)
                                        : new Date()
                                )
                            }
                        </span>
                    </div>
                </div>
            );
        });
    };

    renderTags = (tags) => {
        if (!tags) 
            return null;
        return tags.map((tag, index) => (
            <span key={index} className="tag">
                {tag.name}
            </span>
        ));
    };

    handlePostQuestion = async () => {
        if (this.state.submitting) return;
        const { title, details, tags_text, username } = this.state;
        const trimmedTitle = title.trim();
        const trimmedDetails = details.trim();
        const trimmedUsername = username.trim();
        if (!trimmedTitle || !trimmedDetails || !trimmedUsername) {
            alert("All fields must be filled out.");
            return;
        }
        const tagNames = Array.from(new Set(
            tags_text.split(/\s+/).map(t => t.trim().toLowerCase()).filter(Boolean)
        ));
        if (tagNames.length < 1) {
            alert("Add at least one tag.");
            return;
        }
        if (tagNames.length > 5) {
            alert("At most 5 tags are allowed.");
            return;
        }

        this.setState({ submitting: true });
        try {
            const response = await fetch('/api/questions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    title: trimmedTitle,
                    text: trimmedDetails,
                    tags: tagNames,
                    askedBy: trimmedUsername,
                    askDate: new Date().toISOString()
                })
            });

            if (!response.ok) {
                const e = await response.json().catch(() => null);
                throw new Error(e && e.error ? e.error : response.status + ' ' + response.statusText);
            }

            try {
                localStorage.setItem('fso_last_name', trimmedUsername);
            } catch (e) {}

            await this.fetchData();
            this.setState({
                title: '',
                details: '',
                tags_text: '',
                username: '',
                charCount: 0,
                currentPage: 'main',
                filteredQuestions: null,
                activeButton: 'newest',
                submitting: false
            });
        } catch (error) {
            console.error('Failed to post question:', error);
            alert('Error posting question: ' + error.message);
            this.setState({ submitting: false });
        }
    };

    handleInputChange = (field) => (event) => {
        const {value} = event.target;
        this.setState({[field]: value});

        if (field === 'title') {
            this.setState({charCount: value.length});
        }
    };

    renderInputField = (
        label,
        name,
        rows,
        maxLength,
        value,
        placeholder = '',
        multiline = false,
        hint = ''
    ) => (
        <div className="form_field">
            <h2>{label}</h2>
            {multiline
                ? (
                    <textarea
                        id={name}
                        name={name}
                        rows={rows}
                        maxLength={maxLength}
                        value={value}
                        placeholder={placeholder}
                        onChange={this.handleInputChange(name)}
                        disabled={this.state.submitting}/>
                )
                : (
                    <input
                        type="text"
                        id={name}
                        name={name}
                        maxLength={maxLength}
                        value={value}
                        placeholder={placeholder}
                        onChange={this.handleInputChange(name)}
                        disabled={this.state.submitting}/>
                )}
            {name === 'title' && <p id="charCount">{this.state.charCount}/100</p>}
            {hint && <p className="field_hint">{hint}</p>}
        </div>
    );

    renderAskPage = () => {
        const {title, details, tags_text, username} = this.state;
        return (
            <div id="ask_page" className="ask_page">
                {
                    this.renderInputField(
                        "Question Title*",
                        "title",
                        2,
                        100,
                        title,
                        "Limit title to 100 characters or fewer",
                        false
                    )
                }
                {
                    this.renderInputField(
                        "Question Text*",
                        "details",
                        10,
                        undefined,
                        details,
                        "Add details",
                        true
                    )
                }
                {
                    this.renderInputField(
                        "Tags*",
                        "tags_text",
                        2,
                        undefined,
                        tags_text,
                        "Add keywords separated by white space",
                        true,
                        "Add 1 to 5 tags separated by white space"
                    )
                }
                {
                    this.renderInputField(
                        "Username*",
                        "username",
                        2,
                        undefined,
                        username,
                        "Enter your username",
                        false
                    )
                }

                <button
                    id="post_question"
                    className="blue_button"
                    onClick={this.handlePostQuestion}
                    disabled={this.state.submitting}>
                    Ask Question
                </button>

                <div id="explanation">
                    <p>* indicates mandatory fields</p>
                </div>
            </div>
        );
    };

    handleTitleClick = (question) => {
        if (!question || !question._id) {
            console.error('Invalid question or question ID');
            return; // Exit the function if no valid question or ID
        }

        // First, increment the view count on the server
        fetch(`/api/questions/${question._id}/increment-view`, {method: 'POST'})
            .then(
                response => {
                    if (!response.ok) {
                        throw new Error('Failed to increment views');
                    }
                    return response.json(); // Expecting the updated question as a response
                }
            )
            .then(updatedQuestion => {
                // Now fetch the answers for the updated question
                return fetch(`/api/questions/${question._id}/answers`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to fetch answers');
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.setState({
                            currentQuestion: updatedQuestion, // Use updated question with incremented views
                            currentPage: "answer",
                            currentAnswers: data,
                            currentQid: question._id
                        });
                    });
            })
            .catch(error => {
                console.error('Error during operations:', error);
                alert('Failed to open the question. Please try again.');
            });
    };

    renderAnswerPage() {
        const {currentQuestion, currentAnswers} = this.state;
        if (!currentQuestion) {
            return <div>Question not found.</div>;
        }

        // Sort a copy so state.currentAnswers is never mutated in place.
        const sortedAnswers = [...currentAnswers].sort(
            (a, b) => new Date(b.ans_date_time) - new Date(a.ans_date_time)
        );

        return (
            <div id="answer_page" className="answer_page">
                <button className="back_link" onClick={this.handleMainTitleClick}>
                    ← All Questions
                </button>
                <div id="answer_page_block">
                    <div id="question_detail_answer_number" className="number_of_answer">{sortedAnswers.length}
                        answers</div>
                    <div id="question_title" className="page_subtitle">{currentQuestion.title}</div>
                </div>
                <button
                    id="ask_question"
                    className="blue_button ask_question"
                    onClick={() => {
                        this.setState({currentPage: "ask"});
                        document
                            .getElementById("tags")
                            .style
                            .backgroundColor = "white";
                        document
                            .getElementById("questions")
                            .style
                            .backgroundColor = "white";
                        this.handleButtonClick("newest");
                    }}>
                    Ask Question
                </button>

                <div
                    id="question_block"
                    style={{
                        paddingTop: "30px"
                    }}>
                    <div className="question_view">{currentQuestion.views}
                        views</div>
                    <div className="question_details">{this.renderTextWithLinks(currentQuestion.text)}</div>
                    <div className="question_metadata">
                        <div className="answer_writer">{currentQuestion.asked_by}</div>
                        <div className="answer_time">{this.timeDifference(new Date(), new Date(currentQuestion.ask_date_time))}</div>
                    </div>
                </div>
                <div id="answers_section" className="answer_section">
                    {
                        sortedAnswers.map((answer, index) => (
                            <div key={index} className="answer">
                                <div className="answer_text">{this.renderTextWithLinks(answer.text)}</div>
                                <div className="answer_metadata">
                                    <div className="answer_writer">{answer.ans_by}</div>
                                    <div className="answer_time">{this.timeDifference(new Date(), new Date(answer.ans_date_time))}</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <button
                    id="answer_question"
                    className="blue_button"
                    onClick={() => this.setState({currentPage: "make_answer"})}>
                    Answer Question
                </button>

            </div>
        );
    }

    handleAnswerTextChange = (event) => {
        this.setState({answerText: event.target.value});
    };

    handleAnswerUsernameChange = (event) => {
        this.setState({answerUsername: event.target.value});
    };


    handlePostAnswer = async () => {
        if (this.state.submitting) return;
        const { answerText, answerUsername, currentQid, currentAnswers } = this.state;

        if (!answerText.trim() || !answerUsername.trim() || !currentQid) {
            alert("All fields must be filled out, and a question must be selected.");
            return;
        }

        const newAnswer = {
            text: answerText.trim(),
            ans_by: answerUsername.trim(),
            ans_date_time: new Date().toISOString()
        };

        this.setState({ submitting: true });
        try {
            const response = await fetch(`/api/questions/${currentQid}/answers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newAnswer)
            });

            if (!response.ok) {
                throw new Error(`Failed to post the answer: ${response.status} ${response.statusText}`);
            }

            const postedAnswer = await response.json();

            try {
                localStorage.setItem('fso_last_name', answerUsername.trim());
            } catch (e) {}

            // Refetch the current question's answers plus the full list/counts.
            let fresh;
            try {
                const answersRes = await fetch(`/api/questions/${currentQid}/answers`);
                if (!answersRes.ok) {
                    throw new Error('Failed to refresh answers');
                }
                fresh = await answersRes.json();
            } catch (refreshError) {
                console.error('Failed to refresh answers:', refreshError);
                fresh = [postedAnswer, ...currentAnswers];
            }

            await this.fetchData();

            this.setState({
                currentAnswers: fresh,
                answerText: "",
                answerUsername: "",
                currentPage: "answer",
                submitting: false
            });
        } catch (error) {
            console.error('Error posting the answer:', error);
            alert(`Error posting the answer: ${error.message}`);
            this.setState({ submitting: false });
        }
    };
    
    

    // Rendering links in text
    renderTextWithLinks = (text) => {
        const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;
        const elements = [];
        let lastIdx = 0;
        let match;

        while ((match = linkRegex.exec(text))) {
            const start = match.index;
            const end = linkRegex.lastIndex;
            if (start > lastIdx) {
                elements.push(<span key={lastIdx}>{text.substring(lastIdx, start)}</span>);
            }
            elements.push(
                <a key={start} href={match[2]} target="_blank" rel="noopener noreferrer">
                    {match[1]}
                </a>
            );
            lastIdx = end;
        }

        if (lastIdx < text.length) {
            elements.push(<span key={lastIdx}>{text.substring(lastIdx)}</span>);
        }

        return elements;
    };

    renderMakeAnswerPage = () => {
        const {answerUsername, answerText} = this.state;

        return (
            <div id="make_answer_page" className="answer_page">
                <button className="back_link" onClick={this.handleMainTitleClick}>
                    ← All Questions
                </button>
                <h2>Username</h2>
                <input
                    type="text"
                    id="answer_username"
                    name="answer_username"
                    maxLength="100"
                    value={answerUsername}
                    onChange={this.handleAnswerUsernameChange}
                    placeholder="Enter your username"
                    disabled={this.state.submitting}/>
                <h2>Answer Text</h2>
                <textarea
                    id="answer_text"
                    name="answer_text"
                    rows="10"
                    cols="50"
                    value={answerText}
                    onChange={this.handleAnswerTextChange}
                    placeholder="Type your answer here"
                    disabled={this.state.submitting}/>
                <button
                    id="post_answer"
                    className="blue_button"
                    onClick={this.handlePostAnswer}
                    disabled={this.state.submitting}>
                    Post Answer
                </button>
            </div>
        );
    };

    renderTagsPage = () => {
        const {tags, questions} = this.state;

        return (
            <div id="tags_page" className="answer_page">
                <div id="tag_page_title_block">
                    <div id="total_tags" className="page_title">{tags.length}
                        - Tags</div>
                    <div id="all_tags" className="page_title">All Tags</div>
                </div>
                <button
                    id="ask_question"
                    className="blue_button ask_question"
                    onClick={() => this.handlePageChange("ask")}>
                    Ask Question
                </button>
                <div id="tag_box_container">
                    {
                        tags.map((tag, tagIndex) => (
                            <div key={tagIndex} className="tag_box">
                                <span className="tag_name" onClick={() => this.handleTagClick(tag.name)}>
                                    {tag.name}
                                </span>
                                <div className="tag_box_number_of_questions">
                                    {this.countQuestionsPerTag(tag, questions)}
                                    questions
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    };

    // Helper method to count questions per tag
    countQuestionsPerTag = (tag, questions) => {
        return questions
            .filter(
                question => question.tags.some(t => t.name === tag.name)
            )
            .length;
    };

    handleTagClick = (tagName) => {
        this.searchQuestionsByTag(tagName);
    };

    searchQuestionsByTag = (tagName) => {
        const url = `/api/questions/searchByTag?tag=${encodeURIComponent(tagName)}`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch questions');
                }
                return response.json();
            })
            .then(results => {
                this.setState({
                    filteredQuestions: results,
                    currentPage: "main"
                }, () => this.resetPageStyles());
            })
            .catch(error => {
                console.error('Error fetching questions by tag:', error);
                alert('Failed to load questions for this tag.');
            });
    };

    handlePageChange(page) {
        document
            .getElementById("tags")
            .style
            .backgroundColor = "white";
        document
            .getElementById("questions")
            .style
            .backgroundColor = "white";
        this.setState({currentPage: page});
        this.handleButtonClick('newest');
    }

    render() {
        const { currentPage } = this.state;

        return (
            <div>
                <header>
                    <a
                        className="portfolio_link"
                        href="https://clayborne.dev">
                        ← clayborne.dev
                    </a>
                    <span
                        id="main_title"
                        onClick={this.handleMainTitleClick}
                        style={{
                            cursor: "pointer"
                        }}>
                        Fake Stack Overflow
                    </span>
                    <div id="search_box">
                        <input
                            type="text"
                            id="search_box_input"
                            placeholder="Search..."
                            onKeyUp={this.handleSearchBoxKeyUp}/>
                    </div>
                </header>
                <div className="column">
                    <div id="menu_buttons">
                        <button
                            id="questions"
                            onClick={this.handleQuestionsClick}
                            style={{
                                backgroundColor: "rgb(198, 198, 198)"
                            }}>
                            Questions
                        </button>
                        <button id="tags" onClick={this.handleTagsClick}>
                            Tags
                        </button>
                    </div>
                </div>

                {/* Main Page */}
                {currentPage === "main" && this.displayAllQuestions()}

                {/* Ask Page */}
                {currentPage === "ask" && this.renderAskPage()}

                {/* Answer Page */}
                {currentPage === "answer" && this.renderAnswerPage()}

                {/* Make Answer Page */}
                {currentPage === "make_answer" && this.renderMakeAnswerPage()}

                {/* Tags Page */}
                {currentPage === "tags" && this.renderTagsPage()}
            </div>
        );
    }
}

export default FakeStackOverflow;